// import axios from "axios";
import chargerActionTypes from "../types/chargerActionTypes";
import { ensureArray } from "./../../Utilities/helpers";
import chargePointService from "./../../services/chargePoint.service";


export const getAllChargers = () => async (dispatch) => {
    try {
        var response = await chargePointService.getAllChargers();
        dispatch({
            type: chargerActionTypes.GET_ALL_CHARGERS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_ALL_CHARGERS_FAILURE,
            payload: error.response,
        });
    }

};

export const getChargers = () => async (dispatch) => {
    try {
        var response = await chargePointService.getChargers();
        dispatch({
            type: chargerActionTypes.GET_CHARGER_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_CHARGER_FAILURE,
            payload: error.response,
        });
    }

};

export const getDriverChargers = () => async (dispatch) => {

    try {
        var response = await chargePointService.getDriverChargers();
        dispatch({
            type: chargerActionTypes.GET_DRIVER_CHARGER_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_DRIVER_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

export const getPublicChargers = () => async (dispatch) => {

    try {
        var response = await chargePointService.getPublicChargers();
        dispatch({
            type: chargerActionTypes.GET_PUBLIC_CHARGER_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_PUBLIC_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

export const getFavoriteChargers = () => async (dispatch) => {

    try {
        var response = await chargePointService.getFavoriteChargers();
        dispatch({
            type: chargerActionTypes.GET_FAVORITE_SUCCESS,
            payload: ensureArray(response.data),
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.GET_FAVORITE_FAILURE,
            payload: error.response,
        });

    }
};

export const addFavoriteCharger = (id) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_ADD_FAVORITE
        });
        await chargePointService.addFavoriteCharger(id);
        dispatch({
            type: chargerActionTypes.ADD_FAVORITE_CHARGER_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.ADD_FAVORITE_CHARGER_FAILURE,
            payload: error.response,
        });
        throw error;
    }
};

export const removeFavoriteCharger = (id) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_REMOVE_FAVORITE
        });
        await chargePointService.removeFavoriteCharger(id);
        dispatch({
            type: chargerActionTypes.REMOVE_FAVORITE_CHARGER_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.REMOVE_FAVORITE_CHARGER_FAILURE,
            payload: error.response,
        });
        throw error;
    }
};

export const updateCharger = (charger) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_UPDATE_CHARGER,
        });
        var response = await chargePointService.updateChargerPoint(charger);
        dispatch({
            type: chargerActionTypes.UPDATE_CHARGER_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.UPDATE_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

/*
 * spec 000209 (A5, R2) — returns its own outcome.
 *
 * AddChargerScreen used to learn whether the charger was added by watching `chargerReducer.stateInfo`, an object
 * that add, update, delete, favourite/unfavourite and start/stop transaction all write — and which the SignalR
 * connector-status case used to rebuild while PRESERVING isSuccess. So an unrelated action succeeding while the
 * form was open fired the screen's success handler: a "נוסף בהצלחה" message and a navigation away from a form the
 * operator was still filling in.
 *
 * Additive: every dispatch is unchanged, so `stateInfo` still drives the loader and every other consumer. A
 * caller that ignores the return value behaves exactly as before (clarification Q6 = B — no reducer is
 * restructured here).
 */
export const addCharger = (charger) => async (dispatch) => {

    try {
        dispatch({
            type: chargerActionTypes.START_ADD_CHARGER,
        });
        var response = await chargePointService.addChargePoint(charger);
        dispatch({
            type: chargerActionTypes.ADD_CHARGER_SUCCESS,
            payload: response.data,
        });

        return { success: true, data: response?.data };
    } catch (error) {
        dispatch({
            type: chargerActionTypes.ADD_CHARGER_FAILURE,
            payload: error,
        });

        return { success: false, error };
    }
};

export const deleteCharger = (id) => async (dispatch) => {
    try {
        dispatch({
            type: chargerActionTypes.START_DELETE_CHARGER,
        });
        var response = await chargePointService.deleteChargePoint(id);
        dispatch({
            type: chargerActionTypes.DELETE_CHARGER_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: chargerActionTypes.DELETE_CHARGER_FAILURE,
            payload: error.response,
        });

    }
};

export const setSelectedCharger = (selectedCharger) => (dispatch) => {
    dispatch({ type: chargerActionTypes.SELECT_CHARGER, payload: selectedCharger });
};

export const setMyActiveChargingStationId = (id) => (dispatch) => {
    dispatch({ type: chargerActionTypes.SET_MY_ACTIVE_CHARGER_ID, payload: id });
};

export const UnSelecteCharger = (dispatch) => {
    localStorage.removeItem('selectedCharger');
    dispatch({ type: chargerActionTypes.UNSELECT_CHARGER });
};

export const resetReduxChargers = () => (dispatch) => {
    dispatch({
        type: chargerActionTypes.RESET,
    });

};

export const resetStateInfo = () => (dispatch) => {
    dispatch({ type: chargerActionTypes.RESET_STATE_INFO })
};

export const clearTransactionData = (transaction) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.CLEAR_TRANSACTION_DATA,
        payload: transaction,
    })
}

export const updateChargerGroup = (charger) => async (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CHARGER_GROUP,
        payload: charger,
    });
};

//signalR
// For UpdateConnectorStatus
export const updateConnectorStatus = (message) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CONNECTOR_STATUS,
        payload: message,
    });
}

// For UpdateChargerStatus
export const updateChargerStatus = (message) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CHARGER_STATUS,
        payload: message,
    });
}

// For UpdateChargingSummery
export const updateChargingSummery = (summery) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CHARGING_SUMMERY,
        payload: summery,
    });
}

// For UpdateTransactionData
export const updateTransactionData = (transaction) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_TRANSACTION_DATA,
        payload: transaction,
    });
}

// spec 000196 — the live charging-session state, keyed by transaction id.
//
// Kept as a map rather than a single value because a driver may legitimately have more than one
// session open at once, and a screen showing a parking counter must be certain the amount it is
// showing belongs to the session in front of it. A single slot would show the wrong money the first
// time two sessions overlapped, and would do it silently.
export const updateChargingSessionState = (sessionState) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.UPDATE_CHARGING_SESSION_STATE,
        payload: sessionState,
    });
}

export const clearChargingSessionState = (transactionId) => (dispatch) => {
    dispatch({
        type: chargerActionTypes.CLEAR_CHARGING_SESSION_STATE,
        payload: transactionId,
    });
}

// spec 000273 — a screen opened, reloaded or reconnected after the live frame has nothing to show, because the frame is
// sent once. Reads the persisted state from the server and puts it where the live frame would have put it.
//
// 204 (nothing to show, or the grace notice is still held) and any error leave the store untouched: a missing answer
// must never wipe a live frame, and the banner is a courtesy that must not turn a failed read into an error toast.
// `requestedAt` lets the reducer drop the answer if a live frame arrived while the request was in flight.
export const loadChargingSessionState = (transactionId) => async (dispatch) => {
    if (!transactionId) return;

    const requestedAt = Date.now();
    try {
        const response = await chargePointService.getSessionState(transactionId);
        if (response?.status === 200 && response.data?.transactionId) {
            dispatch({
                type: chargerActionTypes.LOAD_CHARGING_SESSION_STATE,
                payload: { sessionState: response.data, requestedAt },
            });
        }
    } catch {
        // best-effort: an older server (404) or a refused read (403) simply leaves the screen as the live frames do
    }
};

export const getSmartChargingInfo = (transactionId) => async (dispatch) => {
    try {
        const response = await chargePointService.getSmartChargingInfo(transactionId);

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        // Silent fail - caller handles null response
    }
    return null;
}
// For chargePointDetails
export const chargePointDetails = (data) => (dispatch) => {
    try {
        dispatch({
            type: chargerActionTypes.CHARGE_POINT_DETAILS_SUCCESS,
        });
        dispatch(getAllChargers());
    }
    catch (error) {
        dispatch({
            type: chargerActionTypes.CHARGE_POINT_DETAILS_FAILURE,
        });
    }
}



const chargerActions = {
    getAllChargers,
    getChargers,
    getDriverChargers,
    getPublicChargers,
    addCharger,
    updateCharger,
    deleteCharger,
    setSelectedCharger,
    setMyActiveChargingStationId,
    UnSelecteCharger,
    updateTransactionData,
    updateChargingSessionState,
    clearChargingSessionState,
    loadChargingSessionState,
    resetReduxChargers,
    updateChargerStatus,
    clearTransactionData,
    updateChargerGroup,
    updateConnectorStatus,
    getFavoriteChargers,
    addFavoriteCharger,
    removeFavoriteCharger,
    resetStateInfo,
    updateChargingSummery,
    getSmartChargingInfo,
    chargePointDetails
};
export default chargerActions;